import { render, staticRenderFns } from "./MantenimientosPreventivos.vue?vue&type=template&id=67749d47&scoped=true"
import script from "./MantenimientosPreventivos.vue?vue&type=script&lang=js"
export * from "./MantenimientosPreventivos.vue?vue&type=script&lang=js"
import style0 from "./MantenimientosPreventivos.vue?vue&type=style&index=0&id=67749d47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67749d47",
  null
  
)

export default component.exports